export default __webpack_public_path__ + "static/media/1.7ed4a539.png";